<template>
  <v-dialog v-model="advertDialog" width="900">
    <FullImageDialog :chosenAdvert="chosenAdvert" ref="fullImageDialogOpen"></FullImageDialog>
    <v-card>
      <v-toolbar flat class="mb-4">
        <v-spacer></v-spacer>
        <p v-if="$vuetify.breakpoint.smAndUp" class="pr-5 text--primary display-1 pt-5">
          {{chosenAdvert.mainDescription}}
        </p>
        <p v-else class="pt-5 font-weight-bold body-1">
          {{chosenAdvert.mainDescription}}
        </p>
        <v-spacer></v-spacer>
        <v-btn color="error" :title="$t('close window')" class="ma-2" outlined icon large @click="closeDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <!-- <p class="pr-5 text--primary title pt-5 text-center">{{chosenAdvert.mainDescription}}</p> -->
        <v-divider></v-divider>
        <v-divider></v-divider>
        <v-col md="12" v-if="chosenAdvert.image !== ''">
          <v-img :src="chosenAdvert.image" width="100%" height="400px" contain @click.stop="$refs.fullImageDialogOpen.openDialog()"/>
        </v-col>
         <v-row class="ma-0 pa-0">
          <v-col md="12">
            <v-hover>
              <v-card text height="100%" elevation="6" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 0}`">
                <v-card-text>
                  <p class="title text--primary mb-0">{{chosenAdvert.subDescriptionOne}}</p>
                  <p class="title text--primary mb-0">{{chosenAdvert.subDescriptionTwo}}</p>
                  <p class="title text--primary mb-0">{{chosenAdvert.subDescriptionThree}}</p>
                  <!-- <p class="title mb-0 pl-3">{{chosenAdvert.cardDescriptionFour}}</p>
                  <p class="title mb-0 pl-3">{{chosenAdvert.cardDescriptionFive}}</p>
                  <p class="title pl-3 mb-0">{{chosenAdvert.cardDescriptionSix}}</p>
                  <p class="title pl-3 mb-0">{{chosenAdvert.cardDescriptionSeven}}</p>
                  <p class="title pl-3">{{chosenAdvert.cardDescriptionEight}}</p> -->
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </v-row> 
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="warning" @click="closeDialog()">{{$t('close')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import FullImageDialog from "@/pages/frontpage/components/dialog/full_image_dialog.vue";
import AdCardTwoFullImage from "@/components/dialogs/adCardTwoFullImage.vue";
// Import the i18n - This may need to be modified
import messages from "@/pages/frontpage/modules/lang/main/export";
export default {
  components:{
    AdCardTwoFullImage,
    FullImageDialog
  },
  props: {
    chosenAdvert: {
      type:Object
    }
  },
  // Communicate with i18n
  i18n: { messages },
  data(){
    return{
      // Define the dialog v-model that we are using
      advertDialog:false,
    }
  },
  methods: {
    // Opening the dialog through the ref
    openDialog() {
    // this.articledata = articledata;
      this.advertDialog = true;
    },
    // Close the dialog
    closeDialog() {
      this.advertDialog = false;
    }
  }
}
</script>